import { useContext, useEffect, useMemo } from 'react';
import { useSelector } from 'react-redux';

import { MessageContext } from '@/helpers/MessageProvider';
import useParamCommand from '@/hooks/command/mavlink/useParamCommand';
import useMavLinkCommandHandler from '@/hooks/useMavLinkCommandHandler';
import useMavLinkTelemetryHandler from '@/hooks/useMavLinkTelemetryHandler';
import usePingListener from '@/hooks/usePingListener';
import useWaitingRobot from '@/hooks/useWaitingRobot';
import useWaitingRobotTimer from '@/hooks/useWaitingRobotTimer';
import { executeMavLinkCommand } from '@/utils/CommandUtils';

const useOrganizer = (robot) => {
  const { publishCommand } = useContext(MessageContext);
  const address = useSelector((state) => state.telemetry[robot.id]?.address);

  const paramCommand = useParamCommand();

  usePingListener(robot.id);
  useWaitingRobotTimer(robot.id);
  const isWaiting = useWaitingRobot(robot.id);

  useMavLinkTelemetryHandler(robot);
  const { addInterval, clearIntervals } = useMavLinkCommandHandler(robot);

  const [sysId, compId] = useMemo(() => {
    return [address?.sysId, address?.compId];
  }, [address]);

  useEffect(() => {
    if (!robot.isActive) return;
    if (isWaiting) return;
    if (!sysId) return;

    if (robot.isOwned) {
      publishCommand(robot, 'request/autopilot_version', [[sysId, compId]]);
    }

    executeMavLinkCommand(robot, paramCommand.set('BATT_MONITOR', 4, 2));

    addInterval('request/heartbeat', [[]], 1000);
    addInterval('request/message_interval', [[sysId, compId, 245, 1000000]], 11000); // EXTENDED_SYS_STATE

    return () => {
      clearIntervals();
    };
  }, [robot.isActive, isWaiting, sysId]);
};

export default useOrganizer;
